import React, { Component } from 'react';
import App from './App.jsx';
import TablaOportCuadro from './TablaOportCuadro.jsx';
import TablaOportEmpty, { TablaOportEstatica } from './TablaOportEmpty.jsx';

import _ from 'lodash';
import $ from 'jquery';
import moment from 'moment';
import html2canvas from 'html2canvas';
import CircularProgress from 'material-ui/CircularProgress';

import './css/TablaOport.css';
import './css/TablaOportUPL.css';

import { takeDir, snum } from './utils.js';

// Se usa el formato americano: separador de miles ',' y separador decimal '.'
require('numeral/locales/en-gb');
const numeral = require('numeral');

const
  blackTitle     = require('./css/img/central_fert/black_title.png'),
  logoPrecio     = require('./css/img/central_fert/icono_precio.png'),
  logoDescarga   = require('./css/img/central_fert/icono_descarga.png'),
  logoGenerar    = require('./css/img/central_fert/icono_generar.png'),
  logoAgrosat    = require('./css/img/central_fert/agrosat_color.png'),
  logoCliente    = require('./css/img/central_fert/UPL_logo.png'),
  logoBiosense   = require('./css/img/central_fert/Biosense_color.png'),
  logoSoilcheck  = require('./css/img/central_fert/Soilcheck_color.png'),
  logoNutricheck = require('./css/img/central_fert/Nutricheck_color.png')
;

type T_MenuTOportProps = {
  agrosat_user: boolean,
  app: App,
  cond: boolean,
  culti: string,
  current_map: string,
  is_diff: boolean,
  servicio: string
}

type T_MenuTOportState = {
  cultivo: string,
  data: {
    sum: number,
    total_perc: number,
    q1_perc: number,
    q2_perc: number,
    q3_perc: number,
    q1_hect: number,
    q2_hect: number,
    q3_hect: number

  },
  hect: number,
  recom: Array<Array<object>>,
  tifs: Array<string>,
  pngs: Array<string>,
  showPrecio: boolean,
}

export default class TablaOportUPL extends Component<T_MenuTOportProps, T_MenuTOportState> {
  constructor(props: T_MenuTOportProps) {
    super(props);

    this.state = {
      cultivo: '',
      hect: -1,
      loading: false,
      recom: [],
      tifs: [],
      pngs: [],
      showPrecio: false,
      valorRecom: {
        N: -1,
        P: -1,
        K: -1,
        B: -1,
        CA: -1,
        FE: -1,
        ZN: -1,
      }
    }
  }

  componentDidMount() {
    const 
      { app, culti, current_map, is_diff, servicio } = this.props,
      hect = _.sum(app.map_ui.map.Shp_List[culti].obj.dbfRecords.map(rec => {
        return rec.HECTAREAS;
      })),
      cultivo = _.lowerCase(app.map_ui.map.Shp_List[culti].obj.dbfRecords[0].ESPECIE)
    ;

    const ZUCARMEX = ['soilcheck', 'nutricheck_foliar'];
    let _isZucarmex = culti.includes('/MAPS/UPL/CANA-zucarmex') && ZUCARMEX.includes(servicio) ? 
      'cana_zucarmex' : cultivo;


    this.setState({ cultivo, hect });
    
    // Se obtiene el nombre de los .tif en la carpeta
    const
      url_tif   = `${app.remote}/get-tif-png-pairs/?session_id=${app.session()}&dir=${takeDir(culti)}`,
      url_recom = `${app.remote}/get-recom-upl/?session_id=${app.session()}&cultivo=${_isZucarmex}&servicio=${is_diff ? 'diff' : servicio}`
    ;

    fetch(url_recom).then(resp => resp.json()).then(recom_data => {
      const recom = recom_data.map(r => 
        [
          { num: r.r_num1, unit: r.r_unit1, price: r.r_price1, foliar: r.r_f1 },
          { num: r.r_num2, unit: r.r_unit2, price: r.r_price2, foliar: r.r_f2 },
          { num: r.r_num3, unit: r.r_unit3, price: r.r_price3, foliar: r.r_f3 }
        ]
      );

      const elem_units = recom_data.map(r => {
        return {
          elem: r.elem,
          unit: r.unit,
        }
      });

      this.setState({ elem_units, recom });
    });

    fetch(url_tif).then(resp => resp.json()).then(async pairs => {
      const
        tifs = [],
        pngs = []
      ;

      if (_.has(pairs, 'biosense')) {
        tifs.push(pairs.biosense ? pairs.biosense[0] : 'no hay tif');
        pngs.push(pairs.biosense ? pairs.biosense[1] : 'no hay png');
      } else if (_.has(pairs, 'diff') && current_map !== '') {
        tifs.push(current_map.split('/')[7]);
      } else if (_.has(pairs, 'rhumedad') || _.has(pairs, 'M.O')) {
        tifs.push(
          pairs.rhumedad ? pairs.rhumedad[0] : 'no hay tif',
          pairs['M.O']   ? pairs['M.O'][0]   : 'no hay tif'
        );
        pngs.push(
          pairs.rhumedad ? pairs.rhumedad[1] : 'no hay png',
          pairs['M.O']   ? pairs['M.O'][1]   : 'no hay png'
        );
      } else if (_.has(pairs, 'rhumedad_30')) {
        tifs.push(pairs.rhumedad_30 ? pairs.rhumedad_30[0] : 'no hay tif');
        pngs.push(pairs.rhumedad_30 ? pairs.rhumedad_30[1] : 'no hay png');
      } else if (_.has(pairs, 'rethum')) {
        tifs.push(pairs.rethum ? pairs.rethum[0] : 'no hay tif');
        pngs.push(pairs.rethum ? pairs.rethum[1] : 'no hay png');
      } else if (_.has(pairs, 'N') || _.has(pairs, 'P') || _.has(pairs, 'K')) {
        tifs.push(
          pairs.N  ? pairs.N[0]  : 'no hay tif',
          pairs.P  ? pairs.P[0]  : 'no hay tif',
          pairs.K  ? pairs.K[0]  : 'no hay tif',
          pairs.Ca ? pairs.Ca[0] : 'no hay tif',
          pairs.Zn ? pairs.Zn[0] : 'no hay tif',
          pairs.B  ? pairs.B[0]  : 'no hay tif',
          pairs.Fe ? pairs.Fe[0] : 'no hay tif'
        );
        pngs.push(
          pairs.N  ? pairs.N[1]  : 'no hay png',
          pairs.P  ? pairs.P[1]  : 'no hay png',
          pairs.K  ? pairs.K[1]  : 'no hay png',
          pairs.Ca ? pairs.Ca[1] : 'no hay png',
          pairs.Zn ? pairs.Zn[1] : 'no hay png',
          pairs.B  ? pairs.B[1]  : 'no hay png',
          pairs.Fe ? pairs.Fe[1] : 'no hay png'
        );
      } else if (_.has(pairs, 'NO3') || _.has(pairs, 'P') || _.has(pairs, 'K')) {
        tifs.push(
          pairs.NO3 ? pairs.NO3[0] : 'no hay tif',
          pairs.P   ? pairs.P[0]   : 'no hay tif',
          pairs.K   ? pairs.K[0]   : 'no hay tif',
          pairs.Ca  ? pairs.Ca[0]  : 'no hay tif',
          pairs.Zn  ? pairs.Zn[0]  : 'no hay tif',
          pairs.B   ? pairs.B[0]   : 'no hay tif',
          pairs.Fe  ? pairs.Fe[0]  : 'no hay tif'
        );
        pngs.push(
          pairs.NO3 ? pairs.NO3[1] : 'no hay png',
          pairs.P   ? pairs.P[1]   : 'no hay png',
          pairs.K   ? pairs.K[1]   : 'no hay png',
          pairs.Ca  ? pairs.Ca[1]  : 'no hay png',
          pairs.Zn  ? pairs.Zn[1]  : 'no hay png',
          pairs.B   ? pairs.B[1]   : 'no hay png',
          pairs.Fe  ? pairs.Fe[1]  : 'no hay png'
        );
      }

      this.setState({ tifs, pngs });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.culti !== prevProps.culti || this.props.servicio !== prevProps.servicio || this.props.elem_units !== prevProps.elem_units) {
      const
        { app, culti, current_map, is_diff, servicio } = this.props,
        hect = _.sum(app.map_ui.map.Shp_List[culti].obj.dbfRecords.map(rec => {
          return rec.HECTAREAS;
        })),
        cultivo = _.lowerCase(app.map_ui.map.Shp_List[culti].obj.dbfRecords[0].ESPECIE)
      ;

      this.setState({ cultivo, hect });

      const
        url_tif   = `${app.remote}/get-tif-png-pairs/?session_id=${app.session()}&dir=${takeDir(culti)}`,
        url_recom = `${app.remote}/get-recom-upl/?session_id=${app.session()}&cultivo=${cultivo}&servicio=${is_diff ? 'diff' : servicio}`
      ;

      fetch(url_recom).then(resp => resp.json()).then(recom_data => {
        const recom = recom_data.map(r => 
          [
            { num: r.r_num1, unit: r.r_unit1 },
            { num: r.r_num2, unit: r.r_unit2 },
            { num: r.r_num3, unit: r.r_unit3 }
          ]
        );
  
        const elem_units = recom_data.map(r => {
          return {
            elem: r.elem,
            unit: r.unit,
          }
        });
  
        this.setState({ elem_units, recom });
      });
  
      fetch(url_tif).then(resp => resp.json()).then(async pairs => {
        const
          tifs = [],
          pngs = []
        ;
        
        if (_.has(pairs, 'biosense')) {
          tifs.push(pairs.biosense ? pairs.biosense[0] : 'no hay tif');
          pngs.push(pairs.biosense ? pairs.biosense[1] : 'no hay png');
        } else if (_.has(pairs, 'diff') && current_map !== '') {
          // tifs.push(pairs.diff ? pairs.diff[0] : 'no hay tif');
          tifs.push(current_map);
        } else if (_.has(pairs, 'rhumedad') || _.has(pairs, 'M.O')) {
          tifs.push(
            pairs.rhumedad ? pairs.rhumedad[0] : 'no hay tif',
            pairs['M.O']      ? pairs['M.O'][0]      : 'no hay tif'
          );
          pngs.push(
            pairs.rhumedad ? pairs.rhumedad[1] : 'no hay png',
            pairs['M.O']   ? pairs['M.O'][1]   : 'no hay tif'
          );
        } else if (_.has(pairs, 'rhumedad_30')) {
          tifs.push(pairs.rhumedad_30 ? pairs.rhumedad_30[0] : 'no hay tif');
          pngs.push(pairs.rhumedad_30 ? pairs.rhumedad_30[1] : 'no hay png');
        } else if (_.has(pairs, 'rethum')) {
          tifs.push(pairs.rethum ? pairs.rethum[0] : 'no hay tif');
          pngs.push(pairs.rethum ? pairs.rethum[1] : 'no hay png');
        } else if (_.has(pairs, 'N') || _.has(pairs, 'P') || _.has(pairs, 'K')) {
          tifs.push(
            pairs.N  ? pairs.N[0]  : 'no hay tif',
            pairs.P  ? pairs.P[0]  : 'no hay tif',
            pairs.K  ? pairs.K[0]  : 'no hay tif',
            pairs.Ca ? pairs.Ca[0] : 'no hay tif',
            pairs.Zn ? pairs.Zn[0] : 'no hay tif',
            pairs.B  ? pairs.B[0]  : 'no hay tif',
            pairs.Fe ? pairs.Fe[0] : 'no hay tif'
          );
          pngs.push(
            pairs.N  ? pairs.N[1]  : 'no hay png',
            pairs.P  ? pairs.P[1]  : 'no hay png',
            pairs.K  ? pairs.K[1]  : 'no hay png',
            pairs.Ca ? pairs.Ca[1] : 'no hay png',
            pairs.Zn ? pairs.Zn[1] : 'no hay png',
            pairs.B  ? pairs.B[1]  : 'no hay png',
            pairs.Fe ? pairs.Fe[1] : 'no hay png'
          );
        } else if (_.has(pairs, 'NO3') || _.has(pairs, 'P') || _.has(pairs, 'K')) {
          tifs.push(
            pairs.NO3 ? pairs.NO3[0] : 'no hay tif',
            pairs.P   ? pairs.P[0]   : 'no hay tif',
            pairs.K   ? pairs.K[0]   : 'no hay tif',
            pairs.Ca  ? pairs.Ca[0]  : 'no hay tif',
            pairs.Zn  ? pairs.Zn[0]  : 'no hay tif',
            pairs.B   ? pairs.B[0]   : 'no hay tif',
            pairs.Fe  ? pairs.Fe[0]  : 'no hay tif'
          );
          pngs.push(
            pairs.NO3 ? pairs.NO3[1] : 'no hay png',
            pairs.P   ? pairs.P[1]   : 'no hay png',
            pairs.K   ? pairs.K[1]   : 'no hay png',
            pairs.Ca  ? pairs.Ca[1]  : 'no hay png',
            pairs.Zn  ? pairs.Zn[1]  : 'no hay png',
            pairs.B   ? pairs.B[1]   : 'no hay png',
            pairs.Fe  ? pairs.Fe[1]  : 'no hay png'
          );
        }
    
        this.setState({ tifs, pngs });
      });
    }
  }

  generar_img = () => {
    const { app, culti } = this.props;

    this.setState({ loading: true }, () => {
      html2canvas(document.getElementById('descargar_tabla'), { scale: 3 }).then( async (canvas) => {
        const imgsrc = canvas.toDataURL('image/png', 1);
        document.getElementById('newimg').setAttribute('src', imgsrc);
        const dataURL = canvas.toDataURL('image/png', 1);
        $.ajax({
          type: `POST`,
          url: `${app.remote}/gen-tabla-oport/?session_id=${app.session()}`,
          dataType: 'string',
          async: true,
          data: {
            pathCulti: culti,
            imgbase64: dataURL
          }
        });
      }).then(() => this.setState({ loading: false }));
    });
  }

  descargar_img = () => {
    const { app, culti } = this.props;

    app.download(`${app.remote}/get-tabla-oport/?session_id=${app.session()}&pathCulti=${culti}`, 'tablero_oportunidad.png');
  }

  gen_price = () => this.setState({ showPrecio: true });

  render_biosense() {
    const
      { app, culti, is_diff, servicio } = this.props,
      { cultivo, elem_units, hect, recom, tifs, pngs } = this.state,
      cultiName = _.capitalize(culti.split('/')[4].replace(/_/g, ' ')),
      title1 = 'BIOMASA',
      title2 = '% DE DESARROLLO SUBÓPTIMO',
      margen = '% DE DESARROLLO'
    ;

    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }

    if (tifs.length > 0 && pngs.length > 0) {
      return (
        <div>
          <div className="HeaderUPL">
            <div className="CuadroOpt">
              <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px' }}><p><strong>DATOS</strong></p></div>
              <div className="datosPredioUPL">
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Predio</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{cultiName}</p>
                  </div>
                </div>
                <div className="predioBlockUPL" style={{  }}>
                  <div className="predioBlockTitleUPL center">
                    <p>Cultivo</p>
                  </div>
                  <div className="predioBlockDataUPL center">
                    <p style={{ margin: '0px auto 10px auto' }}>{_.capitalize(cultivo)}</p>
                  </div>
                </div>
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Superficie</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{snum(hect, 1)} has</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="CuadroOpt" style={{ width: '278px', display: 'flex', flexFlow: 'column' }}>
              <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px' }}><p><strong>LEYENDA</strong></p></div>
              <div className="leyendaUPL">
                <div className="deficienciaUPL">
                  <div className="ModeradaBlock"/>
                  <p>{margen}</p><p style={{ position: 'relative', bottom: '6px' }}>MODERADO</p>
                </div>
                <div className="deficienciaUPL">
                  <div className="IntermediaBlock"/>
                  <p>{margen}</p><p style={{ position: 'relative', bottom: '6px' }}>BAJO</p>
                </div>
                <div className="deficienciaUPL">
                  <div className="AltaBlock"/>
                  <p>{margen}</p><p style={{ position: 'relative', bottom: '6px' }}>MUY BAJO</p>
                </div>
              </div>
            </div>
          </div>
          <div className="ContentOpt">
            <TablaOportCuadro
              app={app}
              culti={culti}
              cultivo={cultivo}
              is_diff={is_diff}
              hect={hect}
              margen={title2}
              png={pngs[0]}
              recom={recom[0]}
              elem_units={elem_units[0]}
              servicio={servicio}
              tif={tifs[0]}
              title1={title1}
              title2={title2}
            />
          </div>
        </div>
      )      
    }
  }

  render_diff() {
    const
      { app, culti, current_map, is_diff, servicio } = this.props,
      { cultivo, elem_units, hect, recom, tifs, showPrecio } = this.state,
      cultiName = _.capitalize(culti.split('/')[4].replace(/_/g, ' ')),
      title1 = 'DISMINUCIÓN % BIOMASA',
      title2 = '% DE DESARROLLO SUBÓPTIMO'
    ;

    const 
      rango_fecha_inicial = current_map.split('/')[7].replace('.tif', '').split('_')[1],
      rango_fecha_final = current_map.split('/')[7].replace('.tif', '').split('_')[2]
    ;

    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }

    if (tifs.length > 0) {
      return (
        <div>
          <div className="HeaderUPL">
            <div className="CuadroOpt">
              <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px' }}><p><strong>DATOS</strong></p></div>
              <div className="datosPredioUPL">
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Predio</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{cultiName}</p>
                  </div>
                </div>
                <div className="predioBlockUPL left">
                  <div className="predioBlockTitleUPL">
                    <p>Cultivo</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p style={{ margin: '0px auto 10px auto' }}>{_.capitalize(cultivo)}</p>
                  </div>
                </div>
                <div className="predioBlockUPL center">
                  <div className="predioBlockTitleUPL">
                    <p>Superficie</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{snum(hect, 1)} has</p>
                  </div>
                </div>
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Fechas</p>
                  </div>
                  <div className="predioBlockDataUPL" style={{ display: 'block' }}>
                    <p style={{ marginBottom: '0px' }}>{moment(rango_fecha_final).format('DD/MM/YYYY')}</p>
                    <p style={{ marginBottom: '0px' }}>menos</p>
                    <p style={{ marginBottom: '0px' }}>{moment(rango_fecha_inicial).format('DD/MM/YYYY')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ContentOpt">
            <TablaOportCuadro
              app={app}
              culti={culti}
              cultivo={cultivo}
              is_diff={is_diff}
              hect={hect}
              margen={title2}
              png={''}
              recom={recom[0]}
              elem_units={elem_units[0]}
              servicio={servicio}
              showPrecio={showPrecio}
              tif={tifs[0]}
              title1={title1}
              title2={title2}
            />
          </div>
        </div>
      );
    }
  }

  render_soilcheck() {
    const
      { app, culti, is_diff, servicio } = this.props,
      { cultivo, hect, elem_units, recom, tifs, pngs, showPrecio } = this.state,
      cultiName = _.startCase(culti.split('/')[4]), 
      title1 = 'RETENCIÓN DE HUMEDAD',
      title2 = 'MATERIA ORGÁNICA',
      margen = ''
    ;

    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }

    if (tifs.length > 0 && pngs.length > 0) {
      return (
        <div>
          <div className="HeaderUPL">
            <div className="CuadroOpt" style={{ margin: '15px 15px' }}>
              <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px' }}><p><strong>DATOS</strong></p></div>
              <div className="datosPredioUPL">
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Predio</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{cultiName}</p>
                  </div>
                </div>
                <div className="predioBlockUPL center">
                  <div className="predioBlockTitleUPL">
                    <p>Cultivo</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p style={{ margin: '0px auto 10px auto' }}>{_.capitalize(cultivo)}</p>
                  </div>
                </div>
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Superficie</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{snum(hect, 1)} has</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ContentOpt">
            <div style={{ display: 'flex' }}>
              <div className="ContentOpt NutriUPL">
                {tifs[0] !== 'no hay tif' ?
                  (cultivo === 'agave'?
                    null
                    :
                    <TablaOportCuadro
                      app={app}
                      culti={culti}
                      cultivo={cultivo}
                      is_diff={is_diff}
                      hect={hect}
                      margen={margen}
                      png={pngs[0]}
                      recom={recom[0]}
                      elem_units={elem_units[0]}
                      servicio={servicio}
                      showPrecio={showPrecio}
                      tif={tifs[0]}
                      title1={title1}
                      title2={''}
                    />
                  ) 
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
              <div className="ContentOpt NutriUPL" style={{ margin: cultivo === 'agave'  ? '0px 130px' : '0px 5px'}}>
                {tifs[1] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen}
                    png={pngs[1]}
                    recom={recom[1]}
                    elem_units={elem_units[1]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[1]}
                    title1={title2}
                    title2={''}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      )      
    }
  }

  render_nutricheck() {
    numeral.locale('en-gb');

    const
      { app, culti, is_diff, servicio } = this.props,
      { cultivo, hect, elem_units, recom, tifs, pngs, showPrecio, valorRecom } = this.state,
      cultiName = _.startCase(culti.split('/')[4]), 
      title2 = '',
      margen1 = 'Deficiencia',
      margen2 = 'DEFICIENCIA TOTAL'
    ;

    const isZucarmex = culti.includes('/MAPS/UPL/CANA-zucarmex') && servicio === 'nutricheck_foliar';
    const valor_ktionic = isZucarmex ? ((hect * 1) * 7) * 107.52 : 0;

    const prePilotos = ['agave', 'banano', 'pina', 'cana', 'nogal', 'aguacate', 'manzano']; // Esto es sólo apra que no aparezca Estado Fenológico para los casos que tiene sólo una escala

    const checkEscalas = (escalasPNG, f) => escalasPNG.map(png => png.includes(f)).includes(true);

    const calcularValorRecom = (valores, ktionic = 0) => {
      const
        n  = valores.N  !== -1 ? Math.ceil(valores.N)  : 0,
        p  = valores.P  !== -1 ? Math.ceil(valores.P)  : 0,
        k  = valores.K  !== -1 ? Math.ceil(valores.K)  : 0,
        b  = valores.B  !== -1 ? Math.ceil(valores.B)  : 0,
        ca = valores.CA !== -1 ? Math.ceil(valores.CA) : 0,
        fe = valores.FE !== -1 ? Math.ceil(valores.FE) : 0,
        zn = valores.ZN !== -1 ? Math.ceil(valores.ZN) : 0
      ;

      return numeral(n + p + k + b + ca + fe + zn + ktionic).format('0,0');
    };

    if (_.has(this.props, 'cond') && ! this.props.cond) {
      return null;
    }

    if (tifs.length > 0 && pngs.length > 0) {
      return (
        <div>
          <div className="HeaderUPL">
            <div className="CuadroOpt" style={{ marginLeft: '15px' }}>
              <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px' }}><p><strong>DATOS</strong></p></div>
              <div className="datosPredioUPL">
                <div className="predioBlockUPL">
                  <div className="predioBlockTitleUPL">
                    <p>Predio</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p>{cultiName}</p>
                  </div>
                </div>
                <div className={prePilotos.includes(cultivo) ? "predioBlockUPL center" : "predioBlockUPL left"}>
                  <div className="predioBlockTitleUPL">
                    <p>Cultivo</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p style={{ margin: '0px auto 10px auto' }}>{_.capitalize(cultivo)}</p>
                  </div>
                </div>
                <div className={prePilotos.includes(cultivo) ? "predioBlockUPL" : "predioBlockUPL center"}>
                  <div className="predioBlockTitleUPL">
                    <p>Superficie</p>
                  </div>
                  <div className="predioBlockDataUPL">
                    <p style={{ margin: '0px auto 10px auto' }}>{numeral(hect).format('0,0.0')} has</p>
                  </div>
                </div>
                {!prePilotos.includes(cultivo) &&
                  <div className="predioBlockUPL">
                    <div className="predioBlockTitleUPL">
                      <p style={{ whiteSpace: 'nowrap' }}>Estado Fenológico</p>
                    </div>
                    <div className="predioBlockDataUPL">
                      <p>{checkEscalas(pngs, 'f1') ? 'F 1': (checkEscalas(pngs, 'f2') ? 'F 2' : 'F 3')}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
            {showPrecio &&
              <div className="CuadroOpt">
                <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px 40px' }}><p><strong>COSTO RECOMENDACIÓN</strong></p></div>
                <div className="precioTotal">
                  <p>$ {calcularValorRecom(valorRecom, valor_ktionic)}</p>
                </div>
              </div>
            }
            <div className="CuadroOpt" style={{ width: '300px', marginRight: '25px', display: 'flex', flexFlow: 'column' }}>
              <div className="TitleCuadroOpt" style={{ height: '35px', fontSize: '25px', padding: '2px' }}><p><strong>LEYENDA</strong></p></div>
              <div className="leyendaUPL">
                <div className="deficienciaUPL">
                  <div className="ModeradaBlock"/>
                  <p>{margen1}</p><p style={{ position: 'relative', bottom: '6px' }}>moderada</p>
                </div>
                <div className="deficienciaUPL">
                  <div className="IntermediaBlock"/>
                  <p>{margen1}</p><p style={{ position: 'relative', bottom: '6px' }}>intermedia</p>
                </div>
                <div className="deficienciaUPL">
                  <div className="AltaBlock"/>
                  <p>{margen1}</p><p style={{ position: 'relative', bottom: '6px' }}>alta</p>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: 'block', margin: '0px 10px 0px 5px' }}>
            <div style={{ display: 'flex' }}>
              <div className="ContentOpt NutriUPL">
                {tifs[0] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[0]}
                    recom={recom[0]}
                    elem_units={elem_units[0]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[0]}
                    title1={'NITRÓGENO'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
              <div className="ContentOpt NutriUPL">
                {tifs[1] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[1]}
                    recom={recom[1]}
                    elem_units={elem_units[1]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[1]}
                    title1={'FÓSFORO'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
              <div className="ContentOpt NutriUPL">
                {tifs[2] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[2]}
                    recom={recom[2]}
                    elem_units={elem_units[2]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[2]}
                    title1={'POTASIO'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="ContentOpt NutriUPL">
                {tifs[3] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[3]}
                    recom={recom[3]}
                    elem_units={elem_units[3]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[3]}
                    title1={'CALCIO'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
              <div className="ContentOpt NutriUPL">
                {tifs[4] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[4]}
                    recom={recom[4]}
                    elem_units={elem_units[4]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[4]}
                    title1={'ZINC'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
              <div className="ContentOpt NutriUPL">
                {tifs[5] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[5]}
                    recom={recom[5]}
                    elem_units={elem_units[5]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[5]}
                    title1={'BORO'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="ContentOpt NutriUPL">
                {tifs[6] !== 'no hay tif' ?
                  <TablaOportCuadro
                    app={app}
                    parent={this}
                    culti={culti}
                    cultivo={cultivo}
                    is_diff={is_diff}
                    hect={hect}
                    margen={margen2}
                    png={pngs[6]}
                    recom={recom[6]}
                    elem_units={elem_units[6]}
                    servicio={servicio}
                    showPrecio={showPrecio}
                    tif={tifs[6]}
                    title1={'FIERRO'}
                    title2={title2}
                  />
                  :
                  <TablaOportEmpty
                    servicio={servicio}
                  />
                }
              </div>
              <div className="ContentOpt NutriUPL">
              {/* <TablaOportEmpty servicio={servicio} /> */}
                { isZucarmex ? 
                    <TablaOportEstatica servicio={servicio} hect={hect} showPrecio={showPrecio} />
                    : <TablaOportEmpty servicio={servicio} />
                }
              </div>
              <div className="ContentOpt NutriUPL">
                <TablaOportEmpty servicio={servicio} />
              </div>
            </div>
          </div>
        </div>
      )      
    }
  }

  render() {
    const
      { is_diff, servicio } = this.props,
      { recom } = this.state
    ;
    
    if (recom.length > 0) {
      return (
        <div id="oportunidadUPL" className="tablaOportunidadUPL">
          <div title="Generar Tablero de Soluciones" className="gen_image">
            {!this.state.loading ?
              <input type="image" src={logoGenerar} border="0" alt="logo_generar" onClick={this.generar_img}/>
              :
              <div className="loading_image">
                <CircularProgress color={'black'} size={20} thickness={3} value={70} />
              </div>
            }
          </div>
          <div title="Descargar Tablero de Soluciones" className="download_image">
            <input type="image" src={logoDescarga} border="0" alt="logo_descarga" onClick={this.descargar_img}/>
          </div>
          <div title="Generar Valorización de Productos" className="price_image">
            <input type="image" src={logoPrecio} border="0" alt="logo_price" onClick={this.gen_price}/>
          </div>
          <div id="descargar_tabla" className="descargar_tabla">
            <div className="TableroBlackTitle">
              <img className="blackTitle" src={blackTitle} alt="black_title"/>
            </div>
            <div className="HeaderOpt">
              <div className="servicioUPL">
                {servicio === 'biosense' ?
                  <span className="HeaderSubTitle">
                    <img src={logoBiosense} className="img-servicioUPL" alt="logo_servicio" />
                    <span className="HeaderSubTitleSlash">/</span><span style={{ position: 'relative', top: '8px', fontSize: '18px' }}> Control Potencial Productivo</span>
                  </span>
                  
                  :
                  (servicio === 'soilcheck' ? 
                    <span className="HeaderSubTitle">
                      <img src={logoSoilcheck} className="img-servicioUPL" alt="logo_servicio" />
                      <span className="HeaderSubTitleSlash">/</span><span style={{ position: 'relative', top: '8px', fontSize: '18px' }}> Disponibilidad de Agua y Estrés Hídrico</span>
                    </span>
                    :
                    <span className="HeaderSubTitle">
                      <img src={logoNutricheck} className="img-servicioUPL" alt="logo_servicio" />
                      <span className="HeaderSubTitleSlash">/</span><span style={{ position: 'relative', top: '8px', fontSize: '18px' }}> Control Nutricional</span>
                    </span>
                  )
                }
              </div>
              <div className="clienteUPL">
                <img src={logoAgrosat} className="img-agrosatUPL" alt="logo_agrosat" />
                <img src={logoCliente} className="img-clienteUPL" alt="logo_cliente" />
              </div>
            </div>
            {  servicio === 'biosense'  && this.render_biosense() }
            {  servicio === 'biosense'  && is_diff && this.render_diff() }
            {  servicio === 'soilcheck' && this.render_soilcheck() }
            { (servicio === 'nutricheck_foliar' || servicio === 'nutricheck_suelo') && this.render_nutricheck() }
          </div>
          <div id="img" style={{ display: 'none' }}>
            <img src="" alt="" id="newimg" style={{ marginTop: '20px' }} /> 
          </div>
        </div>
      )
    }

    return (
      <div className="CircularProgUPL">
        <CircularProgress color={'lightgrey'} size={200} thickness={10} value={70} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/TablaOportUPL.jsx